// Display only routes already authorised by the containing layout.
export const ADMIN_PRIMARY_IDS = ["dashboard", "clients", "website-production", "tasks", "ai-requests", "support", "approvals", "invoices"];
export const CUSTOMER_PRIMARY_KEYS = ["overview", "requests", "tasks", "freigaben", "documents", "support", "website"];
export const ADMIN_FRIENDLY_LABELS = { dashboard: "Start", clients: "Kunden", "website-production": "Website-Projekte", "ai-requests": "Kundenwünsche" };

export function projectAdminNavigation(groups, { showAll = false, isActive = () => false, dailyLabel, currentLabel } = {}) {
  const all = groups.flatMap(g => g.items);
  const primary = ADMIN_PRIMARY_IDS.map(id => all.find(it => it.id === id)).filter(Boolean);
  const seen = new Set(primary.map(it => it.to));
  const secondary = groups.map(g => ({ ...g, items: g.items.filter(it => {
    if (seen.has(it.to)) return false;
    seen.add(it.to); return true;
  }) })).filter(g => g.items.length);
  const extras = showAll ? secondary : secondary.map(g => ({ ...g, label: currentLabel || g.label, items: g.items.filter(isActive) })).filter(g => g.items.length);
  return { groups: [...(primary.length ? [{ id: "daily", label: dailyLabel, items: primary }] : []), ...extras], extraCount: secondary.reduce((n,g) => n+g.items.length,0) };
}

export function projectCustomerNavigation(items, pathname, showAll = false) {
  const primary = CUSTOMER_PRIMARY_KEYS.map(key => items.find(it => it.key === key)).filter(Boolean);
  const extra = items.filter(it => !CUSTOMER_PRIMARY_KEYS.includes(it.key));
  const active = it => pathname === it.to || (!it.end && pathname.startsWith(it.to + "/"));
  return { items: [...primary, ...(showAll ? extra : extra.filter(active))], extraCount: extra.length };
}

const ADMIN_ACTIONS = [
  ["clients", "Kunden öffnen", "Firma suchen und Details ansehen.", "clients"],
  ["website-production", "Website-Projekte", "Aufträge, Vorschauen und Dokumente prüfen.", "website"],
  ["tasks", "Aufgaben öffnen", "Zuständigkeit und nächsten Schritt prüfen.", "tasks"],
  ["ai-requests", "Kundenwünsche öffnen", "Neue Wünsche lesen und weiterbearbeiten.", "requests"],
  ["invoices", "Rechnungen öffnen", "Rechnungen und ihren Status ansehen.", "invoices"],
  ["support", "Support öffnen", "Offene Fragen der Kunden ansehen.", "support"],
];
const CUSTOMER_ACTIONS = [
  ["requests", "Änderung wünschen", "Beschreiben Sie, was Sie ändern möchten.", "requests"],
  ["tasks", "Freigaben ansehen", "Aufgaben prüfen und Ihre Rückmeldung geben.", "approvals"],
  ["support", "Hilfe bekommen", "Eine Frage stellen oder ein Problem melden.", "support"],
  ["freigaben", "Entwürfe freigeben", "Entwürfe prüfen und Ihre Rückmeldung geben.", "approvals"],
  ["documents", "Dateien öffnen", "Ihre Dokumente und Dateien ansehen.", "documents"],
  ["website", "Website ansehen", "Den hinterlegten Website-Stand ansehen.", "website"],
];
const choose = (definitions, items, key) => definitions.flatMap(([id,label,description,kind]) => {
  const item = items.find(it => it[key] === id);
  return item ? [{ to: item.to, label, description, kind }] : [];
}).slice(0,3);
export const adminWorkActions = items => choose(ADMIN_ACTIONS,items || [],"id");
export const customerWorkActions = items => choose(CUSTOMER_ACTIONS,items || [],"key");

